<template>
    <div class="register-container">
        <div class="form-box">
            <p class="title">
                找回密码
            </p>
            <el-form>
                <el-form-item>
                    <el-input auto-complete="off" placeholder="请输入手机号" v-model="info.account"></el-input>
                </el-form-item>
                <el-form-item class="verification-code">
                    <el-input auto-complete="off"  placeholder="验证码" v-model="info.captcha"></el-input>
                    <el-button @click="sendCaptcha" v-loading="sendCaptchaLoading" :disabled="captchaBtnDisabled">{{captchaBtnText}}</el-button>
                </el-form-item>
                <el-form-item>
                    <el-input auto-complete="off"  type="password" placeholder="请输入新密码" v-model="info.passport"></el-input>
                </el-form-item>
                <el-form-item class="register">
                    <el-button @click="sub">立即提交</el-button>
                </el-form-item>
            </el-form>
            <div class="bottom-box">
                <span>找到密码？</span>
                <router-link to="login">点击登录</router-link>
            </div>
        </div>
    </div>
</template>

<script>
import {
    apiResetPassword,
    apiSendSmsCaptcha
    } from '../../plugins/apis'
import "../../assets/css/register.css";
export default {
    data(){
        return {
            info:{
                account:'',
                passport:'', 
                captcha:'',
            },
            sendCaptchaLoading:false,
            captchaBtnDisabled:false,
            captchaBtnText:'发送验证码',
            second:60,
        }
    },
    methods:{
        async sub (){
            let _data = this.info
            let res = await apiResetPassword(_data)
            if(res.code === 200){
                this.$message.success('修改密码成功，正在跳转到登录页面。。。')
                setTimeout(()=>{
                    this.$router.push('login')
                },1500)
            }else{
                this.$message.error(res.message)
            }
        },
        async sendCaptcha(){
            if(!this.info.account){
                this.$message.error("请输入账号")
                return
            }
            this.sendCaptchaLoading = true
            this.captchaBtnDisabled = true
            let res = await apiSendSmsCaptcha('find_password',this.info.account)
            if(res.code === 200){
                this.$message.success('发送成功')
                this.rushCaptchaBtn()
            }else{
                this.$message.error(res.message)
            }

            this.sendCaptchaLoading = this.captchaBtnDisabled= false
        },
        rushCaptchaBtn(){
            if(this.second === 0){
                this.captchaBtnDisabled = false
                this.second = 60
                this.captchaBtnText = '发送验证码'
            }else{
                --this.second
                this.captchaBtnText = this.second + '秒后重试'
                this.captchaBtnDisabled = true
                setTimeout(()=>{
                    this.rushCaptchaBtn()
                },1000) 
            }
        }
    }
}
</script>

<style>

</style>

